import * as React from "react";
import personalApi from "../../../api/dashboard/personal-api";

type Props = {
  userId: string;
};

const useWeekWorkingInformationBox = <P extends Props>({ userId }: P) => {
  const isMount = React.useRef<boolean>(false);
  const [workingTime, setWorkingTime] = React.useState<number>(0);
  const [maxWorkingTime, setMaxWorkingTime] = React.useState<number>(0);
  const [
    regularRemainingWorkingTime,
    setRegularRemainingWorkingTime
  ] = React.useState<number>(0);
  const [overWorkingTime, setOverWorkingTime] = React.useState<number>(0);
  const [
    overRemainingWorkingTime,
    setOverRemainingWorkingTime
  ] = React.useState<number>(0);

  const handleData = React.useCallback(async () => {
    const params = {
      userId
    };

    try {
      const { data } = await personalApi.getThisWeekWorkingInformationBox(
        params
      );
      const result = data[0];

      if (isMount.current && result) {
        setWorkingTime(result?.astotmin);
        setMaxWorkingTime(result?.aswork_maxmin);
        setOverWorkingTime(result?.asext_maxmin);
        setRegularRemainingWorkingTime(result?.aswork_leavemin);
        setOverRemainingWorkingTime(result?.asext_leavemin);
      }
    } catch (error) {
      console.log(error);
    }
  }, [userId]);

  React.useEffect(() => {
    if (!isMount.current) {
      isMount.current = true;
      handleData();
    }
    return () => {
      if (isMount.current) {
        isMount.current = false;
      }
    };
  }, [handleData]);

  React.useEffect(() => {
    let timeId: NodeJS.Timeout;
    if (isMount.current) {
      timeId = setInterval(handleData, 300000);
    }
    return () => {
      clearInterval(timeId);
    };
  }, [handleData]);

  return {
    workingTime,
    maxWorkingTime,
    regularRemainingWorkingTime,
    overWorkingTime,
    overRemainingWorkingTime
  };
};

export default useWeekWorkingInformationBox;
